







































































































































































































// @ts-nocheck
import axios from 'axios';

export default {
  props: {
    model: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isSaving: false,
      isShowModal: true,
      isShowQuoteDatePicker: false,
      isShowPurchaseOrderDatePicker: false,
      isShowProjectStartDate: false,
      isShowProjectEndDate: false,
      project: {
        id: 0,
        name: '',
        description: '',
        client_id: 0,
        start_date: null as Date | null,
        end_date: null as Date | null,
        purchase_order: '',
        purchase_order_date: null as Date | null,
        quote: '',
        quote_date: null as Date | null,
        quote_amount: 0,
        quote_hours: 0,
        quote_rate: 0
      }
    }
  },
  mounted() {
    if (this.model) {
      this.project = Object.assign({}, this.model);
    }
  },
  computed: {
    clients(): Client[] {
      return this.$store.state.clients;
    },
  },
  methods: {
    async save() {
      try {
        this.isSaving = true;

        const data: any = Object.assign({}, this.project);
        
        debugger;
        if (data.quote_date) {
          data.quote_date = new Date(data.quote_date).toISOString();
        }

        if (data.start_date) {
          data.start_date = new Date(data.start_date).toISOString();
        }

        if (data.end_date) {
          data.end_date =new Date(data.end_date).toISOString();
        }

        if (data.purchase_order_date) {
          data.purchase_order_date = new Date(data.purchase_order_date).toISOString();
        }

        if (data.quote_hours) {
          data.quote_hours = parseFloat(data.quote_hours);
        }

        if (data.quote_rate) {
          data.quote_rate = parseFloat(data.quote_rate);
        }

        let result;

        if (this.project.id) {
          result = await axios.put(`/projects/${this.project.id}`, data);
        } else {
          result = await axios.post('/projects', data);
        }

        this.$emit('save', result.data);
      } catch (error) {
        alert("Failed to save project")
        console.log(error);
      } finally {
        this.isSaving = false;
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    calculateQuoteTotal() {
      this.project.quote_amount = this.project.quote_hours * this.project.quote_rate;
    },
    updateProjectEndDate(value: Date | null) {
      if (value) {
        this.project.end_date = value;
      }

      this.isShowProjectEndDate = false;
    },
    updateProjectStartDate(value: Date | null) {
      if (value) {
        this.project.start_date = value;
      }

      this.isShowProjectStartDate = false;
    },
    updateQuoteDate(value: Date | null) {
      if (value) {
        this.project.quote_date = value;
      }

      this.isShowQuoteDatePicker = false;
    },
    updateProjectOrderDate(value: Date | null) {
      if (value) {
        this.project.purchase_order_date = value;
      }

      this.isShowPurchaseOrderDatePicker = false;
    }
  }
}
